export const START_PROCESS = 'EPIC/START_PROCESS';
export const START_PROCESS_FROM_KEY = 'EPIC/START_PROCESS_FROM_KEY';
export const START_PROCESS_SUCCESS = 'EPIC/START_PROCESS_SUCCESS';
export const START_PROCESS_FAILURE = 'EPIC/START_PROCESS_FAILURE';
